import { UseQueryResult, useQuery } from "@tanstack/react-query";
import axiosInstance from "../../api";
import { useOktaAuth } from "@okta/okta-react";
import OrganizationsResponse from "../../models/API/responseModels/organzationsResponse.model";
import OrganizationDetailModel from "../../models/API/responseModels/organizationDetailResponse.model";
import { useContext } from "react";
import { ApplicationState } from "../../context/ApplicationStateContext";

function usePathLabs(): UseQueryResult<OrganizationsResponse, any> {
  const { authState }: any = useOktaAuth();
  const { dispatch } = useContext(ApplicationState);
  const maskedPhone = (phone: string) => {
    const phoneString = phone.replace(/-/g, "");
    return `${!!phoneString?.[0] ? phoneString?.[0] : ""}${
      !!phoneString?.[1] ? phoneString?.[1] : ""
    }${!!phoneString?.[2] ? phoneString?.[2] : ""}-${
      !!phoneString?.[3] ? phoneString?.[3] : ""
    }${!!phoneString?.[4] ? phoneString?.[4] : ""}${
      !!phoneString?.[5] ? phoneString?.[5] : ""
    }-${!!phoneString?.[6] ? phoneString?.[6] : ""}${
      !!phoneString?.[7] ? phoneString?.[7] : ""
    }${!!phoneString?.[8] ? phoneString?.[8] : ""}${
      !!phoneString?.[9] ? phoneString?.[9] : ""
    }`;
  };
  const roles = authState?.accessToken?.claims?.Profile?.roles;
  const isPLUUser =
    roles?.includes("PathLab User") ||
    roles?.includes("Collaborative Order Agreement");

  return useQuery({
    queryKey: ["pathLabs"],
    queryFn: () =>
      axiosInstance
        .get("/v1/organizations/new-flow/list?type=pathologyLab", {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
          transformResponse: (res) => {
            let response = JSON.parse(res);

            if (response?.data?.length > 0) {
              dispatch({
                type: "SET_PATHLAB",
                payload: response.data[0].id,
              });
              response = {
                ...response,
                data: response?.data?.map((org: OrganizationDetailModel) => ({
                  ...org,
                  phone: maskedPhone(org.phone),
                  fax: maskedPhone(org.fax),
                })),
              };
            }
            return response;
          },
        })
        .then((res) => res?.data),
    enabled: !!authState?.accessToken?.accessToken && isPLUUser,
    staleTime: Infinity,
  });
}

export default usePathLabs;
